
import React from 'react'
import { LayoutServices } from './Layout/LayoutServices'


export const ServicesScreen = () => {
    return (
        <>
            <LayoutServices />
        </>
    )
}